import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import { initialTerminalSummaryState } from "./TerminalSummaryState";
import TerminalSummaryService from "../../app/data/terminal-summary/terminalsummaryService";

const terminalSummaryService = TerminalSummaryService.getInstance();

export const terminalSummarySlice = createSlice({
  name: "terminalSummary",
  initialState: initialTerminalSummaryState,
  reducers: {
    resetTrackShipment: (state) => initialTerminalSummaryState,
    requestStarted: (state, { payload }) => {
      if (payload === "GET_TERMINALS_PORTION") {
        state.fetchPortionStarted = true;
      } else {
        state.requestStarted = true;
      }
      state.requestSucceed = false;
      state.requestFailed = false;
      state.requestCreator = payload;
      state.requestError = "";
    },
    requestSucceed: (state) => {
      state.requestStarted = false;
      state.fetchPortionStarted = false;
      state.requestSucceed = true;
      state.requestFailed = false;
    },
    requestFailed: (state, { payload }) => {
      state.requestStarted = false;
      state.requestSucceed = false;
      state.requestFailed = true;
      state.requestError = payload;
    },
    setTerminallist: (state, { payload }) => {
      state.terminallist = payload;
    },
    addTerminallist: (state, { payload }) => {
      state.terminallist = [...state.terminallist, ...payload];
    },
    setTerminalSummaryRequest: (state, { payload }) => {
      state.terminalSummaryRequest = {
        page: payload.page,
        last: payload.last
      }
    },
    clearTerminalSummaryList: (state) => {
      state.terminallist = [];
    }
  }
});

export const {
  resetTrackShipment,
  requestSucceed,
  requestFailed,
  requestStarted,
  setTerminallist,
  addTerminallist,
  setTerminalSummaryRequest,
  clearTerminalSummaryList,
} = terminalSummarySlice.actions;

export const terminalSummarySelector = (state: IState) => state.terminalSummary;

export const STATIC_ACTIVITY_LOG_ACTION_OPTIONS = [
  { id: "CREATE", name: "CREATE" },
  { id: "UPDATE", name: "UPDATE" },
  { id: "DELETE", name: "DELETE" }
];

export const getTerminalsList = (
  page?: number,
  search?: any,
  region?: any,
  status?: any,
  terminalType?: string | null,
  physicalLocation?: boolean | null
): AppThunk => async (dispatch) => {
  dispatch(requestStarted(page ? "GET_TERMINALS_PORTION" : "GET_TERMINALS"));

  const response = await terminalSummaryService.getTerminalsList(page, search, region, status, terminalType, physicalLocation);
  if (response.isCancel?.()) return;
  if (response.ok()) {
    dispatch(page ? addTerminallist(response?.data.content) : setTerminallist(response?.data.content));
    dispatch(setTerminalSummaryRequest({
      page: response.data?.pageable.pageNumber,
      last: response.data?.last
    }));
    dispatch(requestSucceed());
  } else {
    dispatch(requestFailed(response.getError ? response.getError() : "Error"));
  }
}

const terminalSummaryReducer = terminalSummarySlice.reducer;
export default terminalSummaryReducer;
